import React from 'react';

export default function DevilHornsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="37.69,20.27 34.97,20.27 34.97,14.85 37.69,14.85" fill="#8E2541" />
      <polygon points="34.97,20.27 37.69,20.27 36.87,19.87 34.16,19.87" fill="#3D0F1B" opacity="0.95" />
      <polygon points="34.97,20.27 34.16,19.87 34.16,14.44 34.97,14.85" fill="#3D0F1B" opacity="0.95" />
      <polygon points="5.84,20.27 3.13,20.27 3.13,14.85 5.84,14.85" fill="#8E2541" />
      <polygon points="3.13,20.27 5.84,20.27 5.03,19.87 2.31,19.87" fill="#3D0F1B" opacity="0.95" />
      <polygon points="3.13,20.27 2.31,19.87 2.31,14.44 3.13,14.85" fill="#3D0F1B" opacity="0.95" />
      <polygon points="35.12,25.22 31.29,21.39 34.17,18.51 38.0,22.35" fill="#8E2541" />
      <polygon points="31.29,21.39 35.12,25.22 33.9,24.61 30.07,20.78" fill="#3D0F1B" opacity="0.95" />
      <polygon points="33.9,24.61 35.12,25.22 38.0,22.35 36.78,21.74" fill="#3D0F1B" opacity="0.95" />
      <polygon points="9.93,21.39 6.1,25.22 3.22,22.35 7.05,18.51" fill="#8E2541" />
      <polygon points="6.1,25.22 9.93,21.39 8.71,20.78 4.88,24.61" fill="#3D0F1B" opacity="0.95" />
      <polygon points="6.1,25.22 4.88,24.61 2.0,21.74 3.22,22.35" fill="#3D0F1B" opacity="0.95" />
      <polygon points="34.37,25.56 28.95,25.56 28.95,20.13 34.37,20.13" fill="#8E2541" />
      <polygon points="28.95,25.56 34.37,25.56 32.74,24.74 27.32,24.74" fill="#3D0F1B" opacity="0.95" />
      <polygon points="28.95,25.56 27.32,24.74 27.32,19.32 28.95,20.13" fill="#3D0F1B" opacity="0.95" />
      <polygon points="12.68,25.56 7.26,25.56 7.26,20.13 12.68,20.13" fill="#8E2541" />
      <polygon points="7.26,25.56 12.68,25.56 11.05,24.74 5.63,24.74" fill="#3D0F1B" opacity="0.95" />
      <polygon points="7.26,25.56 5.63,24.74 5.63,19.32 7.26,20.13" fill="#3D0F1B" opacity="0.95" />
    </svg>
  );
}
